"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slugify = void 0;
var v = require("voca");
exports.slugify = function (text, reverse) {
    if (reverse === void 0) { reverse = false; }
    return !reverse ? v.slugify(text) : v.titleCase(text);
};
//# sourceMappingURL=slugify.js.map